<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Aluminium ramen</h1>

      <p>
        Aluminium ramen werden vroeger wel eens geassocieerd aan lastige
        condensatieproblemen. Intussen hebben deze een forse metamorfose
        ondergaan. Door de thermische isolatie is het probleem van de
        condensatie volledig van de baan geruimd.
      </p>

      <p>
        Vaak wordt voor aluminium gekozen wanneer grote raamoppervlakken van
        toepassing zijn. Algemeen genomen zijn ze zowel goed toepasbaar bij
        privéwoningen als bedrijfsgebouwen.
      </p>

      <h2>Waarom kiezen voor aluminium ramen?</h2>

      <ul>
        <li>Aluminium blijft zijn vorm behouden, barst en roest niet</li>
        <li>Geen verkleuring onder invloed van het zonlicht</li>
        <li>Reinigen volstaat met wat water en een vochtige doek</li>
        <li>Goed tegen inbraak</li>
        <li>Beschikbaar in alle kleuren</li>
        <li>Milieuvriendelijk; recycleerbaar</li>
      </ul>

      <p>
        Aluminium ramen maken gebruik van thermisch onderbroken profielen. Deze
        zorgen voor een betere isolatiewaarde. Om de isolatiewaarde goed te
        kunnen meten is er de U-waarde van de aluminium ramen. Een lagere
        U-waarde staat voor een betere isolatiewaarde. Belangrijks is dus om
        vooraf bij de verkoper goed te informeren over deze U-waarde.
      </p>

      <p>
        De enige reden waarom u niet voor aluminium ramen zou kiezen is het feit
        dat ze niet kunnen worden geschilderd, gevoelig zijn voor krasjes en
        iets duurder zijn in aanschaf. Het is dus om goed de voor en nadelen af
        te wegen tussen aluminium ramen, houten ramen en PVC ramen. Onthoud
        alvast dat indien de keuze wordt gemaakt voor aluminium ramen, het erg
        belangrijk is om van bij het begin het juiste kleur te kiezen.
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Aluminium ramen: de voor- en nadelen van aluminium!',
      headDescription:
        'Overweegt u om aluminium ramen aan te schaffen? Op Ramenvergelijker.be leest u alles over aluminium ramen en vergelijkt u gratis offertes!',
      path: '/informatie-over-ramen/aluminium',
    }
  },
}
</script>
